import * as constants from './constants';

// Active Sessions
export const getActiveSessions = (projectId) => ({
  type: constants.GET_ACTIVE_SESSIONS,
  projectId
});

export const getActiveSessionsSuccess = (projectId, sessions) => ({
  type: constants.GET_ACTIVE_SESSIONS_SUCCESS,
  projectId,
  sessions
});

export const getActiveSessionsError = (projectId, error) => ({
  type: constants.GET_ACTIVE_SESSIONS_ERROR,
  projectId,
  error
});

// Historical Sessions
export const getHistoricalSessions = (projectId, page) => ({
  type: constants.GET_HISTORICAL_SESSIONS,
  projectId,
  page
});

export const getHistoricalSessionsSuccess = (
  projectId,
  sessions,
  pagination
) => ({
  type: constants.GET_HISTORICAL_SESSIONS_SUCCESS,
  projectId,
  sessions,
  pagination
});

export const getHistoricalSessionsError = (projectId, error) => ({
  type: constants.GET_HISTORICAL_SESSIONS_ERROR,
  projectId,
  error
});

// End active CVF Session
export const endSession = (projectId, streamingSessionId) => ({
  type: constants.END_SESSION,
  projectId,
  streamingSessionId
});

export const endSessionSuccess = (projectId, streamingSessionId) => ({
  type: constants.END_SESSION_SUCCESS,
  projectId,
  streamingSessionId
});

export const endSessionError = (projectId, streamingSessionId, error) => ({
  type: constants.END_SESSION_ERROR,
  projectId,
  streamingSessionId,
  error
});
